import { type FC, type MouseEvent } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle, Link, Notification } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { IconCircleInfoFilled } from '../../../icons'
import { productAccessorIsContactLenses } from '../../model/productAccessor/productAccessorIsContactLenses'
import { useProductPageContext } from '../productPageContext'

export const ProductPageContactLensesInfoNotification: FC = () => {
  const { currentVariant } = useProductPageContext()

  const isContactLenses = productAccessorIsContactLenses(currentVariant)

  const dialogControls = useOpenableControls()

  if (!isContactLenses) {
    return null
  }

  return (
    <>
      <Notification
        className="mt-2.5 border-dark-brand text-dark-brand"
        icon={<IconCircleInfoFilled />}
        severity="info"
      >
        <p>
          <FormattedMessage id="variantAttributes.contactLens.notification.label" />
          <Link
            className="underline"
            onClick={(event: MouseEvent): void => {
              event.preventDefault()
              event.stopPropagation()
              dialogControls.handleOpen()
            }}
            slots={{ root: 'button' }}
            type="button"
          >
            <FormattedMessage id="variantAttributes.contactLens.notification.clickHere" />
          </Link>
        </p>
      </Notification>
      <Dialog onClose={dialogControls.handleClose} open={dialogControls.isOpen}>
        <DialogTitle onClose={dialogControls.handleClose}>
          <FormattedMessage id="variantAttributes.contactLens.notification.modal.title" />
        </DialogTitle>
        <DialogContent className="m-5 rounded-lg bg-light-primary-low text-dark-primary-strong">
          <FormattedMessage id="variantAttributes.contactLens.notification.modal.infoMassage" />
        </DialogContent>
      </Dialog>
    </>
  )
}
